import { auth } from '../firebase';

// 後端 scanapi 位址。可用 REACT_APP_API_URL 覆蓋（本機/測試環境）。
export const API_BASE =
  process.env.REACT_APP_API_URL || 'https://scanapi-production-4c78.up.railway.app';

// 取得目前登入者的 Firebase ID token，組成 Authorization 標頭給後端驗證用。
// 未登入時回傳空物件（後端若開啟 REQUIRE_AUTH 會回 401）。
export async function getAuthHeader() {
  const user = auth.currentUser;
  if (!user) return {};
  const token = await user.getIdToken();
  return { Authorization: `Bearer ${token}` };
}
